import React from "react";
import { Card } from "@/components/ui/card";

export function StatCard({ icon: Icon, label, value, accent = "primary", testid, onClick }) {
  const accents = {
    primary: "text-primary bg-primary/10",
    gold: "text-amber-400 bg-amber-500/10",
    emerald: "text-emerald-400 bg-emerald-500/10",
    rose: "text-rose-400 bg-rose-500/10",
    blue: "text-blue-400 bg-blue-500/10",
    purple: "text-purple-400 bg-purple-500/10",
  };
  return (
    <Card
      data-testid={testid}
      onClick={onClick}
      className={`relative overflow-hidden rounded-xl border border-border bg-card p-5 hover:border-primary/50 transition-all duration-200 shadow-sm hover:shadow-md group ${onClick ? "cursor-pointer hover:-translate-y-0.5" : ""}`}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
          <p className="mt-2 text-3xl font-bold font-heading tracking-tight" data-testid={`${testid}-value`}>{value}</p>
        </div>
        <div className={`flex h-11 w-11 items-center justify-center rounded-lg ${accents[accent]}`}>
          {Icon && <Icon className="h-5 w-5" />}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
    </Card>
  );
}
